import { render, staticRenderFns } from "./NeedShareDialog.vue?vue&type=template&id=3007df94&scoped=true"
import script from "./NeedShareDialog.vue?vue&type=script&lang=js"
export * from "./NeedShareDialog.vue?vue&type=script&lang=js"
import style0 from "./NeedShareDialog.vue?vue&type=style&index=0&id=3007df94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3007df94",
  null
  
)

export default component.exports